import { produce } from "immer";
import { getCurrentWeek } from "../../utils/dates";
import {
  EXPORT_TIMESHEET,
  EXPORT_TIMESHEET_FAILURE,
  EXPORT_TIMESHEET_SUCCESS,
  FETCH_ALL_SHEET,
  FETCH_ALL_SHEET_FAILURE,
  FETCH_ALL_SHEET_SUCCESS,
  FETCH_ALL_SHIFT,
  FETCH_ALL_SHIFT_FAILURE,
  FETCH_ALL_SHIFT_SUCCESS,
  FETCH_SHEET,
  FETCH_SHEET_FAILURE,
  FETCH_SHEET_SUCCESS,
  GET_ALLOCATION_REPORT,
  GET_ALLOCATION_REPORT_FAILURE,
  GET_ALLOCATION_REPORT_SUCCESS,
  GET_SHEET_HISTORY,
  GET_SHEET_HISTORY_FAILURE,
  GET_SHEET_HISTORY_SUCCESS,
  LOCK_TIMESHEET,
  LOCK_TIMESHEET_FAILURE,
  LOCK_TIMESHEET_SUCCESS,
  SET_ACCRUAL,
  SET_ALLTIMESHEET_WEEK,
  SET_APPROVAL,
  SET_APPROVAL_FAILURE,
  SET_APPROVAL_SUCCESS,
  SET_CLOCK,
  SET_CLOCK_FAILURE,
  SET_CLOCK_SUCCESS,
  SET_CURRENT_EMP,
  SET_DEF_ACCRUAL,
  SET_DEF_PAID,
  SET_PAID,
  SET_REPORT_WEEK,
  SET_TIMESHEET,
  SET_TIMESHEET_WEEK,
  SET_WEEK_STATS,
  TOGGLE_HISTORY,
  TOGGLE_LIST_VIEW,
  TOGGLE_LOCK,
  TOGGLE_MAP_MODAL,
  TOGGLE_TIME_MODAL,
  TOGGLE_VIEW,
  UPDATE_ACCRUAL,
  UPDATE_ACCRUAL_FAILURE,
  UPDATE_ACCRUAL_SUCCESS,
  UPDATE_CLOCK,
  UPDATE_CLOCK_FAILURE,
  UPDATE_CLOCK_SUCCESS,
  GET_RANGE,
  GET_RANGE_SUCCESS,
  GET_RANGE_FAILURE,
  SET_TIMESHEET_RANGE,
  UPDATE_PAID_HOURS,
  UPDATE_PAID_HOURS_SUCCESS,
  UPDATE_PAID_HOURS_FAILURE,
  FETCH_EMPS,
  FETCH_EMPS_SUCCESS,
  FETCH_EMPS_FAILURE,
  FETCH_STATS,
  FETCH_STATS_SUCCESS,
  FETCH_STATS_FAILURE,
  GET_PAYROLL,
  GET_PAYROLL_SUCCESS,
  GET_PAYROLL_FAILURE,
  UPDATE_PAYROLL_RANGE,
  LOCK_PAYROLL,
  LOCK_PAYROLL_SUCCESS,
  LOCK_PAYROLL_FAILURE,
  TOGGLE_LOCK_PAYROLL,
  TOGGLE_SHIFT,
  EXPORT_PAYROLL,
  EXPORT_PAYROLL_SUCCESS,
  EXPORT_PAYROLL_FAILURE,
  UPDATE_SHEET_EMPS,
  FETCH_BREAKS,
  FETCH_BREAKS_SUCCESS,
  FETCH_BREAKS_FAILURE,
  TOGGLE_GALLERY,
  SET_CURRENT_TIMESHEET,
  EXPORT_ALLOCATION,
  EXPORT_ALLOCATION_SUCCESS,
  EXPORT_ALLOCATION_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingSheet: false,
  sheet: [],
  week: getCurrentWeek(),
  listWeek: getCurrentWeek(),
  currentEmp: {},
  timesheet: [],
  isSettingClock: false,
  timeModal: {
    open: false,
    current: {},
  },
  isApproving: false,
  isExporting: false,
  isFetchingAllSheet: false,
  allSheet: [],
  view: "default",
  allShift: [],
  isFetchingAllShift: false,
  allShift: [],
  listView: "default",
  reportWeek: getCurrentWeek(),
  isFetchingReport: false,
  report: [],
  isLocking: false,
  isTimesheetLocked: false,
  mapModal: {
    open: false,
    data: {},
  },
  isFetchingHistory: false,
  sheetHistory: {},
  historyModal: {
    open: false,
    data: {},
  },
  accrualLeave: "",
  defaultAccrualLeave: "",
  paidHours: "",
  defaultPaidHours: "",
  weekStats: {},
  timesheetRange: {},
  sheetRangeList: [],
  isFetchingEmps: false,
  sheetEmployees: [],
  sheetRawEmployees: [],
  isFetchingStats: false,
  sheetStats: {
    total_paid_hours: "00:00:00",
    standard_time: "00:00:00",
    overtime_time: "00:00:00",
  },
  isFetchingPayroll: false,
  payroll: {},
  payrollEmployee: {},
  payrollRange: {},
  isPayrollLocked: false,
  shiftVisible: false,
  exportingData: {
    isFetching: false,
  },
  isFetchingBreaks: false,
  breaksList: [],
  galleryModal: { open: false, list: [] },
  currentTimesheet: {},
  isExportingAllocation: false,
};

const SheetReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_SHEET:
        draft.isFetchingSheet = true;
        draft.sheet = [];
        draft.timesheet = [];
        break;
      case FETCH_SHEET_SUCCESS:
        draft.isFetchingSheet = false;
        draft.sheet = action.payload.data;
        break;
      case FETCH_SHEET_FAILURE:
        draft.isFetchingSheet = false;
        draft.sheet = [];
        draft.timesheet = [];
        break;

      case SET_TIMESHEET_WEEK:
        draft.week = action.payload;
        break;

      case SET_CURRENT_EMP:
        draft.currentEmp = action.payload;
        break;

      case SET_TIMESHEET:
        draft.timesheet = action.payload;
        break;

      case SET_ALLTIMESHEET_WEEK:
        draft.listWeek = action.payload;
        break;

      case SET_CLOCK:
        draft.isSettingClock = true;
        break;
      case SET_CLOCK_SUCCESS:
        draft.isSettingClock = false;
        break;
      case SET_CLOCK_FAILURE:
        draft.isSettingClock = false;
        break;

      case UPDATE_CLOCK:
        draft.isUpdatingClock = true;
        break;
      case UPDATE_CLOCK_SUCCESS:
        draft.isUpdatingClock = false;
        break;
      case UPDATE_CLOCK_FAILURE:
        draft.isUpdatingClock = false;
        break;

      case SET_APPROVAL:
        draft.isApproving = true;
        break;
      case SET_APPROVAL_SUCCESS:
        draft.isApproving = false;
        break;
      case SET_APPROVAL_FAILURE:
        draft.isApproving = false;
        break;

      case EXPORT_TIMESHEET:
        draft.isExporting = true;
        break;
      case EXPORT_TIMESHEET_SUCCESS:
        draft.isExporting = false;
        break;
      case EXPORT_TIMESHEET_FAILURE:
        draft.isExporting = false;
        break;

      case TOGGLE_TIME_MODAL:
        draft.timeModal = action.payload;
        break;
      case TOGGLE_VIEW:
        draft.view = action.payload;
        break;
      case TOGGLE_LIST_VIEW:
        draft.listView = action.payload;
        break;

      case FETCH_ALL_SHEET:
        draft.isFetchingAllSheet = true;
        draft.allSheet = [];
        break;
      case FETCH_ALL_SHEET_SUCCESS:
        draft.isFetchingAllSheet = false;
        draft.allSheet = action.payload;
        break;
      case FETCH_ALL_SHEET_FAILURE:
        draft.isFetchingAllSheet = false;
        draft.allSheet = [];
        break;

      case FETCH_ALL_SHIFT:
        draft.isFetchingAllShift = true;
        draft.allShift = [];
        break;
      case FETCH_ALL_SHIFT_SUCCESS:
        draft.isFetchingAllShift = false;
        draft.allShift = action.payload;
        break;
      case FETCH_ALL_SHIFT_FAILURE:
        draft.isFetchingAllShift = false;
        draft.allShift = [];
        break;

      case GET_ALLOCATION_REPORT:
        draft.isFetchingReport = true;
        draft.report = [];
        break;
      case GET_ALLOCATION_REPORT_SUCCESS:
        draft.isFetchingReport = false;
        draft.report = action.payload;
        break;
      case GET_ALLOCATION_REPORT_FAILURE:
        draft.isFetchingReport = false;
        draft.allShift = [];
        break;

      case SET_REPORT_WEEK:
        draft.reportWeek = action.payload;
        break;

      case LOCK_TIMESHEET:
        draft.isLocking = true;
        draft.isTimesheetLocked = action.payload.is_locked;
        break;
      case LOCK_TIMESHEET_SUCCESS:
        draft.isLocking = false;
        break;
      case LOCK_TIMESHEET_FAILURE:
        draft.isLocking = false;
        break;

      case TOGGLE_LOCK:
        draft.isTimesheetLocked = action.payload;
        break;

      case TOGGLE_MAP_MODAL:
        draft.mapModal = action.payload;
        break;

      case GET_SHEET_HISTORY:
        draft.isFetchingHistory = true;
        draft.sheetHistory = [];
        break;
      case GET_SHEET_HISTORY_SUCCESS:
        draft.isFetchingHistory = false;
        draft.sheetHistory = action.payload;
        break;
      case GET_SHEET_HISTORY_FAILURE:
        draft.isFetchingHistory = false;
        draft.sheetHistory = [];
        break;

      case TOGGLE_HISTORY:
        draft.historyModal = action.payload;
        break;

      case UPDATE_ACCRUAL:
        draft.isUpdatingAccrual = true;
        break;
      case UPDATE_ACCRUAL_SUCCESS:
        draft.isUpdatingAccrual = false;
        break;
      case UPDATE_ACCRUAL_FAILURE:
        draft.isUpdatingAccrual = false;
        break;

      case SET_ACCRUAL:
        draft.accrualLeave = action.payload;
        break;

      case SET_DEF_ACCRUAL:
        draft.defaultAccrualLeave = action.payload;
        break;

      case SET_PAID:
        draft.paidHours = action.payload;
        break;

      case SET_DEF_PAID:
        draft.defaultPaidHours = action.payload;
        break;

      case SET_WEEK_STATS:
        draft.weekStats = action.payload;
        break;

      case GET_RANGE:
        draft.isGettingRange = true;
        draft.sheetRangeList = [];
        break;
      case GET_RANGE_SUCCESS:
        draft.isGettingRange = false;
        draft.sheetRangeList = action.payload ?? [];
        break;
      case GET_RANGE_FAILURE:
        draft.isGettingRange = false;
        draft.sheetRangeList = [];
        break;

      case SET_TIMESHEET_RANGE:
        draft.timesheetRange = action.payload;
        break;

      case UPDATE_PAID_HOURS:
        draft.isUpdatingClock = true;
        break;
      case UPDATE_PAID_HOURS_SUCCESS:
        draft.isUpdatingClock = false;
        break;
      case UPDATE_PAID_HOURS_FAILURE:
        draft.isUpdatingClock = false;
        break;

      case FETCH_EMPS:
        draft.isFetchingEmps = true;
        draft.sheetEmployees = [];
        draft.sheetRawEmployees = [];
        break;
      case FETCH_EMPS_SUCCESS:
        draft.isFetchingEmps = false;
        draft.sheetEmployees = action.payload;
        draft.sheetRawEmployees = action.payload;
        break;
      case FETCH_EMPS_FAILURE:
        draft.isFetchingEmps = false;
        draft.sheetEmployees = [];
        draft.sheetRawEmployees = [];
        break;

      case UPDATE_SHEET_EMPS:
        draft.sheetEmployees = action.payload;
        break;

      case FETCH_STATS:
        draft.isFetchingStats = true;
        draft.sheetStats = {
          total_paid_hours: "00:00:00",
          standard_time: "00:00:00",
          overtime_time: "00:00:00",
        };
        break;
      case FETCH_STATS_SUCCESS:
        draft.isFetchingStats = false;
        draft.sheetStats = action.payload;
        break;
      case FETCH_STATS_FAILURE:
        draft.isFetchingStats = false;
        draft.sheetStats = {
          total_paid_hours: "00:00:00",
          standard_time: "00:00:00",
          overtime_time: "00:00:00",
        };
        break;

      case GET_PAYROLL:
        draft.isFetchingPayroll = true;
        draft.payroll = {};
        break;
      case GET_PAYROLL_SUCCESS:
        draft.isFetchingPayroll = false;
        draft.payroll = action.payload;
        break;
      case GET_PAYROLL_FAILURE:
        draft.isFetchingPayroll = false;
        draft.payroll = {};
        break;

      case UPDATE_PAYROLL_RANGE:
        draft.payrollRange = action.payload;
        break;

      case LOCK_PAYROLL:
        draft.isLockingPayroll = true;
        break;
      case LOCK_PAYROLL_SUCCESS:
        draft.isLockingPayroll = false;
        break;
      case LOCK_PAYROLL_FAILURE:
        draft.isLockingPayroll = false;
        break;

      case TOGGLE_LOCK_PAYROLL:
        draft.isPayrollLocked = action.payload;
        break;

      case TOGGLE_SHIFT:
        draft.shiftView = action.payload;
        break;

      case EXPORT_PAYROLL:
        draft.exportingData = action.payload;
        break;
      case EXPORT_PAYROLL_SUCCESS:
        draft.exportingData = action.payload;
        break;
      case EXPORT_PAYROLL_FAILURE:
        draft.exportingData = action.payload;
        break;

      case FETCH_BREAKS:
        draft.isFetchingBreaks = true;
        draft.breaksList = [];
        break;
      case FETCH_BREAKS_SUCCESS:
        draft.isFetchingBreaks = false;
        draft.breaksList = action.payload;
        break;
      case FETCH_BREAKS_FAILURE:
        draft.isFetchingBreaks = false;
        draft.breaksList = [];
        break;

      case TOGGLE_GALLERY:
        draft.galleryModal = action.payload;
        break;

      case SET_CURRENT_TIMESHEET:
        draft.currentTimesheet = action.payload;
        break;

      case EXPORT_ALLOCATION:
        draft.isExportingAllocation = true;
        break;
      case EXPORT_ALLOCATION_SUCCESS:
        draft.isExportingAllocation = false;
        break;
      case EXPORT_ALLOCATION_FAILURE:
        draft.isExportingAllocation = false;
        break;

      default:
        return state;
    }
  });

export default SheetReducer;
